import { SenderInfo } from './SenderInfo';
export class BaseControlMessage {
    deserializeSenderInfo(senderInfoJson) {
        if (senderInfoJson) {
            this.sender = SenderInfo.fromJson(senderInfoJson);
        }
    }
}
export default BaseControlMessage;
